<template>
  <div v-if="!isLoading">
    <users-form :user.sync="user" :errors="errors" />
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import UsersForm from './UsersForm'
import LoadingContent from './LoadingContent'

export default {
  name: 'UsersEdit',
  props: {
    user: { type: Object, required: true },
    errors: Object
  },
  components: {
    UsersForm,
    LoadingContent
  },
  data () {
    return {
      isLoading: true
    }
  },
  methods: {
    fetchUser () {
      // Busca pelas informações do usuário
      this.isLoading = true
      API.users.show(this.$route.params.user, user => {
        this.$emit('update:user', user)
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.fetchUser()
  },
  watch: {
    '$route' () {
      this.fetchUser()
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "loading": "Loading..."
  },
  "pt-BR": {
    "loading": "Carregando..."
  }
}
</i18n>
